import React from 'react';

const TermsOfService = () => {
  return (
    <div className="page-container terms-theme">
      {/* Enhanced Page Header */}
      <div className="page-header">
        <h1 className="page-main-title">
          📜 የአገልግሎት ውሎች
        </h1>
        <div className="page-subtitle">
          Terms of Service - የአገልግሎት ውል እና ሁኔታዎች
        </div>
        <div className="page-description">
          <p className="page-description-main">
            የኤ-ግጻዌ እና ስንክሳር አገልግሎት የአጠቃቀም ውሎች እና ሁኔታዎች
          </p>
          <p className="page-description-sub">
            Terms and conditions for using E-Gitsawe and Sinksar services
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="content-container">
        <div className="content-header">
          <div className="content-icon">📋</div>
          <h2 className="content-title">የአገልግሎት ውሎች ዝርዝር</h2>
        </div>

        <div className="card-grid">
          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">1</span>
                የአገልግሎት ተቀባይነት
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-blue-50 border-l-4 border-blue-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>በአገልግሎቱ በመጠቀም:</strong><br/>
                    • እነዚህን ውሎች ተቀብለዋል<br/>
                    • ህጋዊ እድሜ ላይ መሆን አለብዎት<br/>
                    • በኢትዮጵያ ህግ መሰረት ይተዳደራል<br/>
                    • የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተ ክርስቲያን ትምህርቶች<br/>
                    • በአክብሮት እና በመንፈሳዊነት መጠቀም
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">2</span>
                የአገልግሎት መግለጫ
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-green-50 border-l-4 border-green-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>የምናቀርባቸው አገልግሎቶች:</strong><br/>
                    • የሊተርጂካል የቀን መቁጠሪያ (ባሕረ ሐሳብ)<br/>
                    • የቅዱሳን ታሪክ (ስንክሳር)<br/>
                    • የጸሎት ሰዓታት እና ማኅሌት<br/>
                    • የመንፈሳዊ መጻሕፍት ስብስብ<br/>
                    • የኅቡዓት ትምህርቶች<br/>
                    • የፍልሰታ መዝሙሮች
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">3</span>
                የተጠቃሚ ኃላፊነቶች
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-purple-50 border-l-4 border-purple-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>እርስዎ የሚጠበቅብዎት:</strong><br/>
                    • አገልግሎቱን በህጋዊ መንገድ መጠቀም<br/>
                    • የቤተ ክርስቲያን ትምህርቶችን በአክብሮት መያዝ<br/>
                    • የሌሎችን መብት ማክበር<br/>
                    • ተገቢ ያልሆነ ይዘት አለመለጠፍ<br/>
                    • የአገልግሎቱን ደህንነት አለመጉዳት<br/>
                    • የቅጂ መብቶችን ማክበር
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">4</span>
                የአገልግሎት ገደቦች
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-orange-50 border-l-4 border-orange-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>የተከለከሉ ተግባራት:</strong><br/>
                    • የአገልግሎቱን ይዘት ለንግድ ዓላማ መጠቀም<br/>
                    • ተገቢ ያልሆነ ይዘት መለጠፍ<br/>
                    • የሌሎችን መብት መጣስ<br/>
                    • የአገልግሎቱን ደህንነት መጉዳት<br/>
                    • ሃሰተኛ መረጃ መስጠት<br/>
                    • የቤተ ክርስቲያን ትምህርቶችን ማዛባት
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">5</span>
                የአገልግሎት ዋስትና
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-red-50 border-l-4 border-red-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>የአገልግሎት ዋስትና:</strong><br/>
                    • አገልግሎቱ "እንዳለ" ይሰጣል<br/>
                    • ቋሚ አገልግሎት ዋስትና አንሰጥም<br/>
                    • ቴክኒካል ችግሮች ሊከሰቱ ይችላሉ<br/>
                    • የይዘት ትክክለኛነት ለማረጋገጥ እንሞክራለን<br/>
                    • የአገልግሎት ማሻሻያ መብት ተጠብቋል<br/>
                    • የአገልግሎት ማቋረጥ መብት አለን
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">6</span>
                የቅጂ መብት እና የአእምሮ ንብረት
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-teal-50 border-l-4 border-teal-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>የአእምሮ ንብረት መብቶች:</strong><br/>
                    • ሁሉም ይዘቶች የቅጂ መብት ተጠብቋል<br/>
                    • የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተ ክርስቲያን ንብረት<br/>
                    • ለግል አጠቃቀም ብቻ ተፈቅዷል<br/>
                    • ለንግድ ዓላማ መጠቀም የተከለከለ ነው<br/>
                    • ምንጩን መጥቀስ ያስፈልጋል<br/>
                    • የሶስተኛ ወገን መብቶች ተጠብቋል
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">7</span>
                የኃላፊነት ገደብ
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-indigo-50 border-l-4 border-indigo-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>የኃላፊነት ገደቦች:</strong><br/>
                    • ቀጥተኛ ወይም ቀጥተኛ ያልሆነ ጉዳት<br/>
                    • የመረጃ ማጣት ወይም ጉዳት<br/>
                    • የሶስተኛ ወገን ድርጊቶች<br/>
                    • የቴክኒካል ችግሮች<br/>
                    • የአገልግሎት መቋረጥ
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">8</span>
                የውል ማሻሻያ እና ማቋረጥ
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-pink-50 border-l-4 border-pink-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>የውል ለውጦች:</strong><br/>
                    • ውሎችን በማንኛውም ጊዜ ማሻሻል እንችላለን<br/>
                    • ለውጦች በድረ-ገጹ ላይ ይወጣሉ<br/>
                    • አገልግሎቱን በመቀጠል ለውጦችን ተቀብለዋል<br/>
                    • አገልግሎቱን በማንኛውም ጊዜ ማቋረጥ እንችላለን<br/>
                    • እርስዎም አገልግሎቱን ማቋረጥ ይችላሉ<br/>
                    • የማቋረጥ መብቶች ተጠብቋል
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="content-container">
        <div className="content-header">
          <div className="content-icon">📞</div>
          <h2 className="content-title">ለጥያቄዎች ያግኙን</h2>
        </div>
        
        <div className="instructions-grid">
          <div className="instruction-card">
            <div className="instruction-header">
              <span className="instruction-icon">📧</span>
              <h3 className="instruction-title">ኢሜይል</h3>
            </div>
            <p className="instruction-description">
              hailemariameyayu2012@gmail.com
            </p>
          </div>

          <div className="instruction-card">
            <div className="instruction-header">
              <span className="instruction-icon">📱</span>
              <h3 className="instruction-title">ስልክ</h3>
            </div>
            <p className="instruction-description">
              +251-938169557
            </p>
          </div>

          <div className="instruction-card">
            <div className="instruction-header">
              <span className="instruction-icon">⚖️</span>
              <h3 className="instruction-title">የሚተዳደርበት ህግ</h3>
            </div>
            <p className="instruction-description">
              የኢትዮጵያ ኦርቶዶክስ ቤተክርስትያን
            </p>
          </div>

          <div className="instruction-card">
            <div className="instruction-header">
              <span className="instruction-icon">🏛️</span>
              <h3 className="instruction-title">ባለ ስልጣን</h3>
            </div>
            <p className="instruction-description">
              የኢትዮጵያ ጠቅላይ በተ ክህነት
            </p>
          </div>
        </div>
      </div>

      {/* Last Updated */}
      <div className="content-container">
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-center">
          <p className="text-sm text-gray-600">
            <strong>የመጨረሻ ማሻሻያ:</strong> ታህሳስ 2017 ዓ.ም (December 2025)<br/>
            <strong>Last Updated:</strong> December 29, 2025<br/>
            <strong>ውል ቁጥር:</strong> EGS-TOS-2025-001
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;